(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ICON = {
    left: '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12.5 4.5 7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    right: '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"><path d="M7.5 4.5 13 10l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    close: '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"><path d="M5 5l10 10M15 5 5 15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
  };

  function wrapSwipe(scroller, getIndex, count, goTo) {
    var startX = null;
    var startIndex = 0;
    scroller.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startIndex = getIndex();
    }, { passive: true });
    scroller.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) < 40 || count() < 2) return;
      if (dx < 0 && startIndex === count() - 1) goTo(0);
      else if (dx > 0 && startIndex === 0) goTo(count() - 1);
    }, { passive: true });
  }

  var lb = null;
  var state = { items: [], index: 0, opener: null };

  function build() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'vr-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Image viewer');
    lb.innerHTML = '<button type="button" class="vr-lb__close" aria-label="Close">' + ICON.close + '</button>' +
      '<div class="vr-lb__track" data-track></div>' +
      '<button type="button" class="vr-lb__nav vr-lb__nav--l" aria-label="Previous image">' + ICON.left + '</button>' +
      '<button type="button" class="vr-lb__nav vr-lb__nav--r" aria-label="Next image">' + ICON.right + '</button>' +
      '<div class="vr-lb__count" data-count></div>';
    document.body.appendChild(lb);
    var track = lb.querySelector('[data-track]');
    lb.querySelector('.vr-lb__close').addEventListener('click', close);
    lb.querySelector('.vr-lb__nav--l').addEventListener('click', function () { go(state.index - 1); });
    lb.querySelector('.vr-lb__nav--r').addEventListener('click', function () { go(state.index + 1); });
    track.addEventListener('click', function (e) { if (!e.target.closest('img')) close(); });
    track.addEventListener('scroll', function () {
      if (state.resizing) return;
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i !== state.index) { state.index = i; count(); }
    }, { passive: true });
    wrapSwipe(track, function () { return state.index; }, function () { return state.items.length; }, go);
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        if (lb.hidden) return;
        state.resizing = true;
        track.scrollTo({ left: state.index * track.clientWidth, behavior: 'auto' });
        clearTimeout(state.timer);
        state.timer = setTimeout(function () { state.resizing = false; }, 200);
      }).observe(track);
    }
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Tab') {
        var focusables = Array.prototype.filter.call(lb.querySelectorAll('button'), function (b) { return b.offsetParent !== null; });
        if (!focusables.length) return;
        var firstEl = focusables[0];
        var lastEl = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
        else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
        else if (!lb.contains(document.activeElement)) { e.preventDefault(); firstEl.focus(); }
      } else if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(state.index - 1);
      else if (e.key === 'ArrowRight') go(state.index + 1);
    });
    return lb;
  }

  function count() {
    lb.querySelector('[data-count]').textContent = state.items.length > 1 ? (state.index + 1) + ' / ' + state.items.length : '';
    lb.classList.toggle('is-single', state.items.length < 2);
  }

  function go(i) {
    var n = state.items.length;
    if (!n) return;
    var next = (i % n + n) % n;
    var track = lb.querySelector('[data-track]');
    state.index = next;
    track.scrollTo({ left: next * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    count();
  }

  function close() {
    if (!lb || lb.hidden) return;
    lb.hidden = true;
    document.documentElement.classList.remove('vr-lb-open');
    if (state.opener && state.opener.focus) state.opener.focus({ preventScroll: true });
  }

  window.VRWrapSwipe = wrapSwipe;
  window.VRLightbox = {
    open: function (items, index, opener) {
      if (!items || !items.length) return;
      build();
      var track = lb.querySelector('[data-track]');
      track.textContent = '';
      items.forEach(function (it, n) {
        var slide = document.createElement('div');
        slide.className = 'vr-lb__slide';
        var img = document.createElement('img');
        img.src = it.src;
        img.alt = it.alt || '';
        img.decoding = 'async';
        if (Math.abs(n - index) > 1) img.loading = 'lazy';
        slide.appendChild(img);
        track.appendChild(slide);
      });
      state.items = items;
      state.index = index || 0;
      state.opener = opener || null;
      lb.hidden = false;
      document.documentElement.classList.add('vr-lb-open');
      track.scrollTo({ left: state.index * track.clientWidth, behavior: 'auto' });
      count();
      lb.querySelector('.vr-lb__close').focus({ preventScroll: true });
    }
  };
})();
